import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import forwardArrow from "../../Assets/next-arrow.png";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-background" />
      <div className="hero-overlay" />
      <div className="hero-glow hero-glow-one" />
      <div className="hero-glow hero-glow-two" />
      <div className="hero-grid" />

      <motion.div
        className="hero-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
      >
        <motion.div
          className="hero-badge"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.22, 1, 0.36, 1]
          }}
        >
    
          <span>End-to-End Production</span>
        </motion.div>

        <div className="hero-title-wrapper">
          <span className="hero-background-text">
            ETOE
          </span>

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 45 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.9,
              delay: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }}
          >
            <span className="hero-title-line">
              We Create
            </span>

            <span className="hero-title-line hero-title-accent">
              Brand Experiences
            </span>
          </motion.h1>
        </div>

        <motion.p
          className="hero-description"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.45,
            ease: [0.22, 1, 0.36, 1]
          }}
        >
          ETOE Productions is a creative agency delivering end-to-end solutions in production, branding,
           design, development, and digital marketing
           From compelling visual storytelling to high-performing digital experiences, 
           we create work that inspires, connects, and drives growth
        </motion.p>

        <motion.div
          className="hero-actions"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }}
        >
          <Link to="/work" className="hero-primary-btn">
            <span>Explore Our Work</span>

            <span className="hero-arrow-wrapper">
              <img
                src={forwardArrow}
                alt=""
                className="forward-arrow"
              />
            </span>
          </Link>

          <Link to="/about" className="hero-secondary-btn">
            <span>About ETOE</span>
          </Link>
        </motion.div>
      </motion.div>

     

     
    </section>
  );
}

export default Hero;